import { baseApi } from "../baseApi";

export const cityApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({

    // CREATE CITY
    createFaq: builder.mutation({

      query: (data) => ({
        url: "/faq-create",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["FAQ"],
    }),

    // GET CITY
    getFaq: builder.query({
      query: ({ page = 1,limit = 10,search = "",status = "",}={}) => 
        `/faq-list?page=${page}&limit=${limit}&search=${search}&status=${status}`,
      providesTags: ["FAQ"],
    }),

    // UPDATE CITY
    updateFaq: builder.mutation({
      query: (data) => ({
        url: `/faq-edit`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["FAQ"],
    }),

    changeStatausFaq: builder.mutation({
      query: (id) => ({
        url: `/faq-status/${id}`,
        method: "GET",
        }),
      invalidatesTags: ["FAQ"],
    }),

 deleteFaq: builder.mutation({
  query: (data) => ({
    url: `/faq-delete`,
    method: "DELETE",
    body:data
  }),

  invalidatesTags: ["FAQ"],
})

  })

});

export const {

  useCreateFaqMutation,
  useGetFaqQuery,
  useUpdateFaqMutation,
  useDeleteFaqMutation,

} = cityApi;